/**
 * CBF Serpenteo – Scroll trigger para modo simple
 *
 * Observa todos los elementos .cbf-serpenteo--simple y añade la clase
 * .cbf-serpenteo--in-view cuando entran al viewport, disparando la
 * animación CSS cbf-char-in letra por letra.
 *
 * La clase se añade una sola vez (unobserve tras el primer disparo).
 * El threshold de 0.1 garantiza que la animación empieza cuando el
 * 10 % del span es visible — lo suficiente para que el usuario lo perciba.
 */
(function () {
  'use strict';

  function initSerpenteoScroll() {
    if (!document.body.classList.contains('cbf-serpenteo-on')) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cbf-serpenteo--in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.cbf-serpenteo--simple').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSerpenteoScroll);
  } else {
    initSerpenteoScroll();
  }
})();
